import Box from '@mui/material/Box'

export interface PixQRCodeProps {
  imgSrc: string
}

export const PixQRCode: React.FC<PixQRCodeProps> = ({ imgSrc }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        padding: 3,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: -8,
            borderRadius: 3,
            border: '2px solid',
            borderColor: 'primary.main',
            opacity: 0.4,
            animation: 'pulseRing 2s ease-in-out infinite',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: -16,
            borderRadius: 4,
            border: '1.5px solid',
            borderColor: 'primary.light',
            opacity: 0.2,
            animation: 'pulseRing 2s ease-in-out 0.5s infinite',
          },
          '@keyframes pulseRing': {
            '0%, 100%': { opacity: 0.15, transform: 'scale(1)' },
            '50%': { opacity: 0.4, transform: 'scale(1.03)' },
          },
        }}
      >
        <Box
          component="img"
          src={imgSrc}
          alt="QR Code - Pix"
          sx={{
            width: '100%',
            maxWidth: 200,
            borderRadius: 2,
            display: 'block',
          }}
        />
      </Box>
    </Box>
  )
}

export const LoadingPaymentAnimation: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      py: 4,
    }}
  >
    <Box
      sx={{
        width: 100,
        height: 100,
        borderRadius: '50%',
        border: '3px solid',
        borderColor: 'primary.light',
        borderTopColor: 'primary.main',
        animation: 'spin 1s linear infinite',
        '@keyframes spin': {
          '0%': { transform: 'rotate(0deg)' },
          '100%': { transform: 'rotate(360deg)' },
        },
      }}
    />
    <Box
      sx={{
        position: 'absolute',
        width: 50,
        height: 50,
        borderRadius: '50%',
        backgroundColor: 'primary.main',
        opacity: 0.1,
        animation: 'pulse 1.5s ease-in-out infinite',
        '@keyframes pulse': {
          '0%, 100%': { transform: 'scale(1)', opacity: 0.1 },
          '50%': { transform: 'scale(2.5)', opacity: 0.05 },
        },
      }}
    />
  </Box>
)
